import { fetchRequisitionsDrilldown } from './actions';
import { getDefaultAtsFilters, buildReportsSlice } from '../common/ats-filters';

const constructDrilldownData = (payload) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;
  const k5Map = payload?.data?.lookups?.k5;

  const returnData = payload?.data?.table?.map((data) => {
    // eslint-disable-next-line no-unused-vars
    const [, k1, k2, k3, k4, k5, time_to_fill, action_user_name] = data;
    return {
      req_code: k1Map?.[k1],
      office_id: k2Map?.[k2],
      filled_application_id: k3Map?.[k3],
      action_performed_by_id: k4Map?.[k4],
      job: k5Map?.[k5],
      time_to_fill: time_to_fill,
      action_user_name: action_user_name,
    };
  });
  return returnData;
};

const initialState = {
  ...getDefaultAtsFilters(),

  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  totalCount: 0,
  currentDrillPage: 1,
};

const extraReducers = {
  [fetchRequisitionsDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchRequisitionsDrilldown.fulfilled]: (state, { meta, payload = {} }) => {
    if (!payload) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;

    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload);

    state.totalCount = payload?.data?.pagination?.total_count;

    if (drilldown.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown.page;
  },
  [fetchRequisitionsDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsRequisitionsReport',
  initialState,
  extraReducers,
});

export const {
  applyFilter,
  setFiltersData,
  resetFilter,
  applyTimeFrame,
  applyViewBy,
  applyGroup,
  applySearch,
  resetDrillDown,
} = actions;
export default reducer;
